import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { VngSelectOption } from "@vengreso/angular-components";
import { BaseSettingsSectionComponent } from "../base-settings-section.component";
import { ExtensionSettingsService } from "../extension-settings.service";

export interface SeparatorOption {
  label: string;
  value: string;
}

export const PREDEFINED_SEPARATORS: SeparatorOption[] = [
  { label: "Comma (,)", value: "," },
  { label: "Semicolon (;)", value: ";" },
  { label: "Pipe (|)", value: "|" },
  { label: "Tab", value: "\t" },
  { label: "Space", value: " " },
];

@Component({
    selector: "app-csv-separator-settings",
    templateUrl: "./csv-separator-settings.component.html",
    styleUrls: ["./csv-separator-settings.component.scss"],
    standalone: false
})
export class CsvSeparatorSettingsComponent extends BaseSettingsSectionComponent implements OnInit, OnChanges {
  @Input() initialSeparator: string | null = null;

  readonly separatorOptions = PREDEFINED_SEPARATORS;
  private lastSavedSeparator: string | null;

  constructor(
    private readonly fb: FormBuilder,
    private readonly settingsService: ExtensionSettingsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.lastSavedSeparator = this.initialSeparator ?? null;
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialSeparator && !changes.initialSeparator.firstChange) {
      this.lastSavedSeparator = changes.initialSeparator.currentValue ?? null;
      if (this.form) {
        this.form.get("separator").setValue(this.lastSavedSeparator);
        this.markPristine();
      }
    }
  }

  buildForm(): FormGroup {
    return this.fb.group({
      separator: [this.initialSeparator ?? null],
    });
  }

  get selectedSeparator(): string | null {
    return this.form.get("separator").value;
  }

  // vng-select is data-driven ([options]) — 04-component-gaps-and-issues.md / R5.
  get separatorSelectOptions(): VngSelectOption[] {
    return [
      { value: null, label: "None" },
      ...this.separatorOptions.map((sep) => ({ value: sep.value, label: sep.label })),
    ];
  }

  getSaveObservable(): Observable<any> {
    const separator = this.selectedSeparator;
    this.lastSavedSeparator = separator;
    return this.settingsService.saveCsvSplitSeparator(separator);
  }

  resetToLastSaved(): void {
    this.form.get("separator").setValue(this.lastSavedSeparator);
  }
}
